import {authservices} from '../services/authServices';
import { Toast } from 'primereact/toast';
import {useRef} from 'react';
import { NavLink } from 'react-router';
import {useStock} from '../contexts/stockContexts'; 
import ForecastOrdersHeader from './artifacts/orderforcast'; 
import SalesForecastHeader from './artifacts/salesForcast'; 
import ShopifyHeader from './artifacts/shopifycomp'; 
import Outofstock from '../assets/images/icons8-alert-96.png';
const Header = () => {
   const toast = useRef(null);
   const {instock,stockItems,ordergraphsdata,settingsdata,getSettingValue} = useStock();
   const logout = () =>{
      //  console.log("logout");
       const token = localStorage.getItem('token');
       let objdata = {'token':token};
       authservices.logout(objdata).then((response)=>{
          //  console.log(response);  
           if(response.status == 200){
              toast.current.show({ severity: 'success', summary: 'Logout', detail: 'Successfully logged out!' }) 
              localStorage.clear(); 
              window.location.href = '/login';
            }else{
              toast.current.show({ severity: 'error', summary: 'Logout', detail: response.data.data.message }) 
           }  
       }).catch((error)=>{
           console.log(error); 
           localStorage.clear(); 
           window.location.href = '/login';     
       });
   }  
  const data = JSON.parse(localStorage.getItem('userdata'));

  //  const 
  //  const getdata = ()=>{
  //       localStorage.getItem('userdata'); 
	// 		localStorage.setItem('permissons',permissions);
	// 		localStorage.setItem('companydata',companydata);
	// 		localStorage.setItem('logo',logo);
  //  }

  const  Items = () =>{
      let itemsdata = [];
      stockItems.forEach((value) =>{
         itemsdata.push(  <a href="#">
          <div class="notif-img">
            <i className="fa fa-product"></i>
          </div>
          <div class="notif-content">
            <span class="subject">{value.product_name}</span>
            <span class="block"> {value.stock_type}</span>
            <span class="time">{value.remaining_quantity}</span>
          </div>
        </a> );
      }) 
     return itemsdata;   
  }

   return(
      <>
        <Toast ref={toast} />
         <div class="main-header">
           <div class="main-header-logo">
             <div class="logo-header" data-background-color="dark">
              <a href="index.html" class="logo">
                Utan
                {/* <img
                  src="../assets/img/kaiadmin/logo_light.svg"
                  alt="navbar brand"
                  class="navbar-brand"
                  height="20"
                /> */}
              </a>
              <div class="nav-toggle">
                <button class="btn btn-toggle toggle-sidebar">
                  <i class="gg-menu-right"></i>
                </button>
                <button class="btn btn-toggle sidenav-toggler">
                  <i class="gg-menu-left"></i>
                </button>
              </div>
              <button class="topbar-toggler more">
                <i class="gg-more-vertical-alt"></i>
              </button>
              </div>
           </div>
           <nav
            class="navbar navbar-header navbar-header-transparent navbar-expand-lg border-bottom"
          >
            <div class="container-fluid">
              <nav
                class="navbar navbar-header-left navbar-expand-lg navbar-form nav-search p-0 d-none d-lg-flex"
              >
                <h3>Welcome <span className='text-xs text-success' style={{texttransform: 'capitalize'}}>{data?.name}</span></h3>
                
              </nav>
              &nbsp;
              &nbsp;

             
             <div style={{display:'flex'}}>
               <div style={{display:'flex'}}>
                  <div style={{display:'flex',alignitems:'center'}}><b style={{style:'18px'}}>{getSettingValue('default_currency')}</b></div>
                  &nbsp;
                  &nbsp;
                  {/* <ShopifyHeader/>   */}
                  <SalesForecastHeader/>
                  &nbsp;
                  &nbsp;
                  <ForecastOrdersHeader />
              </div>
                   <ul class="navbar-nav topbar-nav align-items-center">
                <li
                  class="nav-item topbar-icon dropdown hidden-caret d-flex d-lg-none"
                >
                  <a
                    class="nav-link dropdown-toggle"
                    data-bs-toggle="dropdown"
                    href="#"
                    role="button"
                    aria-expanded="false"
                    aria-haspopup="true"
                  >
                    <i class="fa fa-search"></i>
                  </a>
                  <ul class="dropdown-menu dropdown-search animated fadeIn">
                    <form class="navbar-left navbar-form nav-search">
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Search ..."
                          class="form-control"
                        />
                      </div>
                    </form>
                  </ul>
                </li>

                {instock ? (<li class="nav-item topbar-icon dropdown hidden-caret">
                  {/* <a
                    class="nav-link dropdown-toggle text-danger"
                    href="#"
                    id="messageDropdown"
                    // role="button"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img src={Outofstock} style={{width:'24px'}}/>
                   
                  </a> */}
                  <ul
                    class="dropdown-menu messages-notif-box animated fadeIn"
                    aria-labelledby="messageDropdown"
                  >
                    <li>
                      <div
                        class="dropdown-title d-flex justify-content-between align-items-center"
                      >
                        Out of Stocks
                        
                        {/* <a href="#" class="small">Mark all as read</a> */}
                      </div>
                    </li>
                    <li>
                      <div class="message-notif-scroll scrollbar-outer" style={{'overflowY': 'scroll'}}>
                        <div class="notif-center">
                          {Items()}
                         
                        </div>
                      </div>
                    </li>
                    {/* <li>
                      <a class="see-all" href="javascript:void(0);"
                        >See all messages<i class="fa fa-angle-right"></i>
                      </a>
                    </li> */}
                  </ul>
                </li>) : (<></>)}  
                
                &nbsp;&nbsp;&nbsp;&nbsp;
               
                
                {/* <li class="nav-item topbar-icon dropdown hidden-caret">
                  <a
                    class="nav-link dropdown-toggle"
                    href="#"
                    id="messageDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="fa fa-envelope"></i>
                   
                  </a>
                  <ul
                    class="dropdown-menu messages-notif-box animated fadeIn"
                    aria-labelledby="messageDropdown"
                  >
                    <li>
                      <div
                        class="dropdown-title d-flex justify-content-between align-items-center"
                      >
                        Messages
                        
                        <a href="#" class="small">Mark all as read</a>
                      </div>
                    </li>
                    <li>
                      <div class="message-notif-scroll scrollbar-outer">
                        <div class="notif-center">
                          <a href="#">
                            <div class="notif-img">
                              <img
                                src="../assets/img/jm_denis.jpg"
                                alt="Img Profile"
                              />
                            </div>
                            <div class="notif-content">
                              <span class="subject">Jimmy Denis</span>
                              <span class="block"> How are you ? </span>
                              <span class="time">5 minutes ago</span>
                            </div>
                          </a>
                          <a href="#">
                            <div class="notif-img">
                              <img
                                src="../assets/img/chadengle.jpg"
                                alt="Img Profile"
                              />
                            </div>
                            <div class="notif-content">
                              <span class="subject">Chad</span>
                              <span class="block"> Ok, Thanks ! </span>
                              <span class="time">12 minutes ago</span>
                            </div>
                          </a>
                          <a href="#">
                            <div class="notif-img">
                              <img
                                src="../assets/img/mlane.jpg"
                                alt="Img Profile"
                              />
                            </div>
                            <div class="notif-content">
                              <span class="subject">Jhon Doe</span>
                              <span class="block">
                                Ready for the meeting today...
                              </span>
                              <span class="time">12 minutes ago</span>
                            </div>
                          </a>
                          <a href="#">
                            <div class="notif-img">
                              <img
                                src="../assets/img/talha.jpg"
                                alt="Img Profile"
                              />
                            </div>
                            <div class="notif-content">
                              <span class="subject">Talha</span>
                              <span class="block"> Hi, Apa Kabar ? </span>
                              <span class="time">17 minutes ago</span>
                            </div>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li>
                      <a class="see-all" href="javascript:void(0);"
                        >See all messages<i class="fa fa-angle-right"></i>
                      </a>
                    </li>
                  </ul>
                </li> */}
                {/* <li class="nav-item topbar-icon dropdown hidden-caret">
                  <a
                    class="nav-link dropdown-toggle"
                    href="#"
                    id="notifDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="fa fa-bell"></i>
                    <span class="notification">4</span>
                  </a>
                  <ul
                    class="dropdown-menu notif-box animated fadeIn"
                    aria-labelledby="notifDropdown"
                  >
                    <li>
                      <div class="dropdown-title">
                        You have 4 new notification
                      </div>
                    </li>
                    <li>
                      <div class="notif-scroll scrollbar-outer">
                        <div class="notif-center">
                          <a href="#">
                            <div class="notif-icon notif-primary">
                              <i class="fa fa-user-plus"></i>
                            </div>
                            <div class="notif-content">
                              <span class="block"> New user registered </span>
                              <span class="time">5 minutes ago</span>
                            </div>
                          </a>
                          <a href="#">
                            <div class="notif-icon notif-success">
                              <i class="fa fa-comment"></i>
                            </div>
                            <div class="notif-content">
                              <span class="block">
                                Rahmad commented on Admin
                              </span>
                              <span class="time">12 minutes ago</span>
                            </div>
                          </a>
                          <a href="#">
                            <div class="notif-img">
                              <img
                                src="assets/img/profile2.jpg"
                                alt="Img Profile"
                              />
                            </div>
                            <div class="notif-content">
                              <span class="block">
                                Reza send messages to you
                              </span>
                              <span class="time">12 minutes ago</span>
                            </div>
                          </a>
                          <a href="#">
                            <div class="notif-icon notif-danger">
                              <i class="fa fa-heart"></i>
                            </div>
                            <div class="notif-content">
                              <span class="block"> Farrah liked Admin </span>
                              <span class="time">17 minutes ago</span>
                            </div>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li>
                      <a class="see-all" href="javascript:void(0);"
                        >See all notifications<i class="fa fa-angle-right"></i>
                      </a>
                    </li>
                  </ul>
                </li> */}
                {/* <li class="nav-item topbar-icon dropdown hidden-caret">
                  <a
                    class="nav-link"
                    data-bs-toggle="dropdown"
                    href="#"
                    aria-expanded="false"
                  >
                    <i class="fas fa-layer-group"></i>
                  </a>
                  <div class="dropdown-menu quick-actions animated fadeIn">
                    <div class="quick-actions-header">
                      <span class="title mb-1">Quick Actions</span>
                      <span class="subtitle op-7">Shortcuts</span>
                    </div>
                    <div class="quick-actions-scroll scrollbar-outer">
                      <div class="quick-actions-items">
                        <div class="row m-0">
                          <a class="col-6 col-md-4 p-0" href="#">
                            <div class="quick-actions-item">
                              <div class="avatar-item bg-danger rounded-circle">
                                <i class="far fa-calendar-alt"></i>
                              </div>
                              <span class="text">Calendar</span>
                            </div>
                          </a>
                          <a class="col-6 col-md-4 p-0" href="#">
                            <div class="quick-actions-item">
                              <div
                                class="avatar-item bg-warning rounded-circle"
                              >
                                <i class="fas fa-map"></i>
                              </div>
                              <span class="text">Maps</span>
                            </div>
                          </a>
                          <a class="col-6 col-md-4 p-0" href="#">
                            <div class="quick-actions-item">
                              <div class="avatar-item bg-info rounded-circle">
                                <i class="fas fa-file-excel"></i>
                              </div>
                              <span class="text">Reports</span>
                            </div>
                          </a>
                          <a class="col-6 col-md-4 p-0" href="#">
                            <div class="quick-actions-item">
                              <div
                                class="avatar-item bg-success rounded-circle"
                              >
                                <i class="fas fa-envelope"></i>
                              </div>
                              <span class="text">Emails</span>
                            </div>
                          </a>
                          <a class="col-6 col-md-4 p-0" href="#">
                            <div class="quick-actions-item">
                              <div
                                class="avatar-item bg-primary rounded-circle"
                              >
                                <i class="fas fa-file-invoice-dollar"></i>
                              </div>
                              <span class="text">Invoice</span>
                            </div>
                          </a>
                          <a class="col-6 col-md-4 p-0" href="#">
                            <div class="quick-actions-item">
                              <div
                                class="avatar-item bg-secondary rounded-circle"
                              >
                                <i class="fas fa-credit-card"></i>
                              </div>
                              <span class="text">Payments</span>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </li> */}

                <li class="nav-item topbar-user dropdown hidden-caret">
                  <a
                    class="dropdown-toggle profile-pic"
                    data-bs-toggle="dropdown"
                    href="#"
                    aria-expanded="false"
                  >
                    <div class="avatar-sm">
                      <img
                        src="assets/img/profile.jpg"
                        alt="..."
                        class="avatar-img rounded-circle"
                      />
                    </div>
                    <span class="profile-username">
                      <span class="op-7">Hi,</span>
                      <span class="fw-bold">{data?.name}</span>
                    </span>
                  </a>
                  <ul class="dropdown-menu dropdown-user animated fadeIn">
                    <div class="dropdown-user-scroll scrollbar-outer">
                      <li>
                        <div class="user-box">
                          <div class="avatar-lg">
                            <img
                              src="assets/img/profile.jpg"
                              alt="image profile"
                              class="avatar-img rounded"
                            />
                          </div>
                          <div class="u-text">
                            <h4>{data?.name}</h4>
                            <p class="text-muted">{data?.email}</p>
                          <NavLink to='/profile'><i class="btn btn-xs btn-secondary">View Profile</i></NavLink>
                            {/* <a
                              href="/profile"
                              class="btn btn-xs btn-secondary btn-sm"
                              >View Profile</a> */}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="dropdown-divider"></div>
                        {/* <a class="dropdown-item" href="#">My Profile</a> */}
                        <NavLink className="dropdown-item" to='/profile'> My Profile</NavLink>

                        {/* <a class="dropdown-item" href="#">My Balance</a>
                        <a class="dropdown-item" href="#">Inbox</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="#">Account Setting</a> */}
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" style={{cursor:'pointer'}} onClick={()=>logout()}>Logout</a>
                      </li>
                    </div>
                  </ul>
                </li>
                
              </ul>
              </div>     
             
            </div>
          </nav>
         </div>
       
      </> 
   );
}
export default Header;
    


       